export default "__VITE_ASSET__Dq76OWg2__"